import { render, staticRenderFns } from "./baseCodeTable.vue?vue&type=template&id=66b743ae&scoped=true&"
import script from "./baseCodeTable.vue?vue&type=script&lang=js&"
export * from "./baseCodeTable.vue?vue&type=script&lang=js&"
import style0 from "./baseCodeTable.vue?vue&type=style&index=0&id=66b743ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b743ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b743ae')) {
      api.createRecord('66b743ae', component.options)
    } else {
      api.reload('66b743ae', component.options)
    }
    module.hot.accept("./baseCodeTable.vue?vue&type=template&id=66b743ae&scoped=true&", function () {
      api.rerender('66b743ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/commBaseCodeManage/detail/baseCodeTable.vue"
export default component.exports